export default "__VITE_ASSET__e6Ms53bV__"